import { faArrowRightLong } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LINK_OF_ALL_PAGES } from "const/common";
import Link from "next/link";
import { useRouter } from "next/router";
import { memo } from "react";

const ServicesHeader = (properties) => {
  const router = useRouter();
  return (
    <div
      className={`bg-header-background bg-bottom bg-no-repeat bg-cover flex items-end ${
        router.pathname === LINK_OF_ALL_PAGES.services.digitalMarketing
          ? "pt-56 xl:pt-72 justify-center text-center"
          : "px-4 pt-16 md:px-10 md:pt-56 xl:pt-72"
      }`}
    >
      <div className="pt-28 md:pt-0">
        <div className="pb-4 flex items-end">
          <Link href={LINK_OF_ALL_PAGES.services.servicesMain}>
            <a className="text-sm md:text-xl font-medium text-primary-yellow">
              <span className="flex items-center">
                Service
                <FontAwesomeIcon
                  className="text-sm text-primary-yellow"
                  height={20}
                  icon={faArrowRightLong}
                  width={40}
                />
              </span>
            </a>
          </Link>
          <span className="text-sm md:text-xl font-medium text-primary-yellow">
            {properties.pageName}
          </span>
        </div>
        <h1 className="text-4xl md:text-6xl md:leading-tight font-medium text-white mb-2">
          <span dangerouslySetInnerHTML={{ __html: properties.heading }}></span>
        </h1>
        <span className="text-xl md:text-3xl font-medium text-white">
          {properties.subHeading}
        </span>
        <p className="text-base font-medium text-white w-full md:w-11/12 mb-4">
          <span
            dangerouslySetInnerHTML={{ __html: properties.details }}
            className="[&>a]:text-blue-500"
          ></span>
        </p>
      </div>
    </div>
  );
};

export default memo(ServicesHeader);
